<dw-content-manager configKey="covid-home" *ngIf="showCovidSection">

    <h1><img style="width: 100px;height:auto;margin-top:25px;" src="./assets/wachter/images/covid2.png">
        <dw-content name="title" display="Covid Title" [controlType]="textboxControlType">
            Wachter Covid Information
        </dw-content>
    </h1>
    <hr />

    <div style="width:800px" *ngIf="false">
        <div class="covid-background">
            <div class="title-location">
                <dw-content name="title" display="Covid Title" [controlType]="textboxControlType">
                    Wachter Covid Information
                </dw-content>
            </div>
        </div>
    </div>

    <dw-html-view [ngModel]="covidConfig?.HomePageMessage"></dw-html-view>

    <div class="card-container">
       <div class="card" style="width: 18rem;"
            [hidden]="covidHomeView != 'employeeNoWeeklyTesting'">
            <div class="card-body">
                <h5 class="card-title">
                    <dw-content name="FullyVaccinate_Title" display="Fully Vaccinated Title"
                        [controlType]="textboxControlType">
                        Fully Vaccinated
                    </dw-content>
                </h5>
                <p class="card-text">
                    <dw-content name="FullyVaccinate_Detail" display="Fully Vaccinated Text">
                        Since you're fully vaccinated, you are not required to do weekly testing! However, if
                        you test postivie, we need to know to keep your work environment safe!
                    </dw-content>
                </p>
                <a href="#" class="card-link"
                    [routerLink]="'/human-resources/saftey/covid-tracking/covid-tests/add'">Log Covid Test</a>

                <ng-container *ngTemplateOutlet="employeeStatus">
                </ng-container>
            </div>
        </div>

        <div class="card" style="width: 18rem;"
            [hidden]="covidHomeView != 'employeeWeeklyTesting'">
            <div class="card-body">
                <h5 class="card-title">
                    <dw-content name="NotFullyVaccinate_Title" display="Not Fully Vaccinated Title"
                        [controlType]="textboxControlType">
                        Weekly Testing Required
                    </dw-content>
                </h5>
                <p class="card-text">
                    <dw-content name="NotFullyVaccinate_Detail" display="Not Fully Vaccinated Text">
                        Since you're not fully vaccinated, you are required to do weekly testing! However,
                        if you get fully vaccinated, you will no longer have to do this.
                    </dw-content>

                </p>
                <a href="#" class="card-link"
                    [routerLink]="'/human-resources/saftey/covid-tracking/covid-tests/add'">Log Covid Test</a>
                <a href="#" class="card-link"
                    [routerLink]="'/human-resources/saftey/covid-tracking/vaccination-submissions/add'">Log
                    vaccinatation</a>

                <ng-container *ngTemplateOutlet="employeeStatus">
                </ng-container>
            </div>
        </div>

        <div class="card" style="width: 18rem;" 
        [hidden]="covidHomeView != 'wachterNoEmployeeTesting'">
            <div class="card-body">
                <h5 class="card-title">
                    <dw-content name="NoWeeklyTesting_Title" display="No Weekly Testing Title"
                        [controlType]="textboxControlType">
                        Weekly testing not Required
                    </dw-content>
                </h5>
                <div class="card-text">
                    <dw-content name="NoWeeklyTesting_Detail" display="No Weekly Testing Detail">
                        Wachter is not requiring weekly testing at this time! However, if you test positive, we need to know to keep your work environment safe!
                    </dw-content>
                </div>
                <a href="#" class="card-link"
                    [routerLink]="'/human-resources/saftey/covid-tracking/covid-tests/add'">Log Covid Test</a>
            </div>
        </div> 
    </div>

</dw-content-manager>


<ng-template #employeeStatus>
    <br><br>
    <ng-container *ngIf="employeeSummary.CovidWorkStatusId == 1">
        <div class="card-text dw-green">
            <i class="fa fa-check-circle"></i> {{employeeSummary.CovidWorkStatusIdDisplay || 'Able to Work'}}
        </div>
        <div class="card-text dw-green" [hidden]="!employeeSummary.RequiresWeeklyTesting">
            <i class="fa fa-check-circle"></i> Your next test date is {{ employeeSummary.NextTestDate | date}}
        </div>
    </ng-container>

    <ng-container *ngIf="employeeSummary.CovidWorkStatusId == 2">
        <div class="card-text">
            <div class="dw-red">
                <i class="fa fa-times"></i> {{employeeSummary.CovidWorkStatusIdDisplay}}
            </div>
            You are required to Quarantine until {{employeeSummary.QuarantineEndDate | date}}
        </div>
    </ng-container>

    <ng-container *ngIf="employeeSummary.CovidWorkStatusId == 3">
        <div class="card-text">
            <div class="dw-red">
                <i class="fa fa-times"></i> {{employeeSummary.CovidWorkStatusIdDisplay}}
            </div>
            You are required to submit a test before you are able to work
        </div>
    </ng-container>
</ng-template>